<nz-card class="header-card" nzSize="small">
  <div class="flex justify-start flex-wrap gap-0 xsm:gap-2">
    <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  </div>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">{{ title }}</h2>
  </div>
</nz-card>

<!-- Loader -->
<div *ngIf="loading" class="loader">Loading files...</div>

<!-- Extracted images and videos -->
<div class="extracted-media grid md:grid-cols-2 xl:grid-cols-3 gap-5 w-full mt-10" *ngIf="!loading">
  <ng-container *ngFor="let media of extractedImages">
    <div class="bg-white rounded-md relative cursor-pointer">
      <img class="w-full rounded-lg h-full object-cover" [src]="media" alt="Extracted Image" loading="lazy" (click)="openImageModal(media)" (error)="onImageError($event)" />
    </div>
  </ng-container>

  <ng-container *ngFor="let media of extractedVideos">
    <div class="bg-white rounded-md relative">
      <video class="w-full rounded-lg h-full object-cover" controls>
        <source [src]="media" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </ng-container>
</div>

<!-- Full-screen Image Modal -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50" (click)="closeImageModal()">
  <img [src]="selectedImage" alt="" class="max-w-full max-h-full object-contain" (click)="$event.stopPropagation()" />
</div>
